var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99955 9.99957C8.79984 9.99957 8.6081 9.9181 8.46662 9.77347L0.220904 1.3188C-0.0736347 1.01684 -0.0736347 0.527791 0.220904 0.226473C0.515443 -0.0754909 0.992248 -0.0754909 1.28637 0.226473L8.99981 8.13545L16.7138 0.227024C17.0083 -0.0749395 17.4851 -0.0749395 17.7793 0.227024C18.0734 0.528988 18.0738 1.01781 17.7793 1.31935L9.53246 9.77347C9.39118 9.91831 9.19945 10 8.99973 10L8.99955 9.99957Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorArrowDown);
export default __webpack_public_path__ + "static/media/vector-arrow-down.7b0b6f31e747668b408b5f6b4adab96f.svg";
export { ForwardRef as ReactComponent };